import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {UserData} from "../fonzie/auth/user.data";
import {UserService} from "../fonzie/auth/user.service";

@Component({
    selector: "fhm-routing-page",
    template: "",
    providers: [UserService],
    standalone: false
})
export class RoutingPageComponent implements OnInit {

    constructor(private userService: UserService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.redirect();
    }

    async redirect(): Promise<void> {
        const loggedUser: UserData = await this.userService.getLoggedUser();
        if (UserData.isSalesManager(loggedUser)) {
            this.router.navigate(["/main/sales-signup-search"]);
        } else {
            this.router.navigate(["/main/customer-instance-venue-edit/new"]);
        }
    }
}
